<template>
  <div>
    <div class="msg_shade"></div>
    <div class="msg_box" :style="{width:mwidth+'px',height:mheight+'px',marginLeft:-mwidth/2+'px',marginTop:-mheight/2+'px'}">
      <h3 class="title" v-if="title">{{title}}</h3>
      <slot></slot>
      <div class="salerMaskbtnBox" v-show="show_button">
        <button class="btn btn_blue" @click="confirm">确定</button>
        <button class="btn cacelBtn" @click="cancel">取消</button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name:"msgTips",
    props:{
      title:"",
      mwidth:{
        default:520
      },
      mheight:{
        default:250
      },
      showButton:{
        default:true
      }
    },
    data(){
      return {
        show_button:true
      }
    },
    methods:{
      confirm(){
        this.$emit("confirm")
      },
      cancel() {
        this.$emit("cancel")
      }
    },
    watch:{
      'showButton':function(){
        this.show_button=this.showButton
      }
    }
  }
</script>

<style lang="less" scoped>
  .msg_shade{
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: #000;
    opacity: 0.3;
    filter: alpha(opacity=30);
    z-index:999;
  }
  .msg_box{
    padding:20px;
    position: fixed;
    top:50%;
    left:50%;
    border: 1px solid #fff;
    border-radius: 3px;
    background-color: #fff;
    box-shadow: 1px 1px 50px rgba(0,0,0,.3);
    z-index:1000;
    box-sizing: border-box;
  h3{
    font-weight: normal;
    padding-bottom:20px;
    color:#32363a;
    font-size:16px;
  }
  .salerMaskbtnBox{
    margin-top:32px;
    text-align:center;
  }
  }
</style>




// WEBPACK FOOTER //
// src/components/layer/msgTips.vue